module.exports = __webpack_public_path__ + "static/img/yiclogo-05.430f71f3.svg";